module.exports = __webpack_public_path__ + "img/avatar-s-11.51a23c07.png";